import React from "react"
import { ExclamationCircleIcon } from "@heroicons/react/24/outline"
import Button from "aldoo-ra/Button"
import useT from "../hooks/useT"
import ProductScrollableList from "./ProductScrollableList"

/**
 * What a product page renders while the product is not offered: the store
 * product's `enabled` is off, so there is nothing to buy and nothing to read
 * about it — the visitor is sent back to the catalog instead.
 *
 * The product is still addressable (an old link, a bookmark, a search result
 * that has not expired), so this answers where the page would be rather than
 * pretending the product never existed.
 */
export default function ProductUnavailable({ name }) {
  const t = useT()
  return (
    <div className="flex flex-col items-center text-center px-4 py-24 sm:py-32" data-testid="product-unavailable">
      <ExclamationCircleIcon className="w-16 h-16 text-text_secondary/60" />
      <h1 className="mt-6 mb-0 text-[24px] sm:text-[30px] font-bold text-text">
        {t`This product is not available`}
      </h1>
      {name && <p className="mt-2 mb-0 text-[16px] text-text_secondary">{name}</p>}
      <p className="mt-4 mb-0 max-w-[520px] text-[15px] text-text_secondary">
        {t`It is no longer offered in the store. Browse the catalog for what is available now.`}
      </p>
      <Button variant="primary_l" href="/categories" className="mt-8">
        {t`Go to the catalog`}
      </Button>
      {/* something to look at instead: the store's latest, right here */}
      <div className="w-full max-w-[1280px] mt-16 px-0 md:px-[30px]">
        <ProductScrollableList placement="unavailable" category="latest" title={t`Latest`} itemsPerPage={10} />
      </div>
    </div>
  )
}
